var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgradeLightningBoltIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.735 8.27h3.867c.46 0 .877.284 1.008.707.191.426.07.907-.277 1.207l-8.877 7.64a1.126 1.126 0 01-1.384.061c-.419-.3-.571-.846-.367-1.313l2.667-6.118H1.474c-.43 0-.845-.284-1.007-.706A1.078 1.078 0 01.775 8.54L9.65.901A1.125 1.125 0 0111.034.84c.42.3.572.844.368 1.313L8.735 8.27z"
  })));
}
export default SvgUpgradeLightningBoltIcon;